// extracted by mini-css-extract-plugin
export default {"fieldset":"MailingInput_fieldset__t+JgB","input":"MailingInput_input__wKfGL","errorBorder":"MailingInput_errorBorder__BQ6f1","error":"MailingInput_error__Y-6WC"};